import React, { useEffect, useState } from 'react'


const ScrollTop = () => {

  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scorlled upto given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 400) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
  }, []);


  return (
    <>
      {isVisible &&
        <div onClick={scrollToTop} className="scrollToTop">
          <i className="fi-rr-arrow-small-up"></i>
        </div>}
    </>
  )
}

export default ScrollTop